import React from "react";
import "./About.css";
import MainMenu from "../components/navigations/MainMenu";

const AboutUs = () => {
  return (
    <div className="relative about">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div
        className="pt-20 about__container flex justify-center items-center"
        style={{
          backgroundImage: `linear-gradient(
          rgb(200, 200, 200, 0.7),
          rgb(0, 0, 0, 0.9)
  ), url("/images/about.JPG")`,
          height: "90vh",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      >
        <div className="">
          <p className="text-xl font-bold font-serif text-white">About</p>
          <h1 className="text-white text-center font-bold text-6xl font-serif">
            ST. JOHN HIGH SCHOOL
          </h1>
        </div>
      </div>
      <div className="p-6 mb-10 font-serif max-w-3xl mx-auto">
        <p>
          <span className="font-bold">St. John's High School</span> is an
          English Medium School with a Boarding Facility. It was founded by the
          UBA(Udaipur Baptist Association) on the 20th August 1988, At Embru
          Panthor(Khakchang Hathi) near Killa. It was then shifted to Raio in
          1991. This School was established with a view of educating the chidren
          of the interior villages of Tripura.{" "}
          <span>
            {" "}
            It was upgraded to Senior Basic School in 1997 and to High School in
            1999. It is recognized by the Department of Education-Govt. of
            Tripura and was affiliated to TBSE and later it was converted to
            CBSE 2015.
          </span>{" "}
          <br />
          <span>
            It also aims to give children a sound physical, intellectual, moral
            and spritual education based on Christian Principles.
          </span>{" "}
          <br />
          <span>
            This NGo School is run and managed by the UBA(Udaipur Baptist
            Association) whose prime aim and objectives are mentioned in the
            memorandum of UBA. And Thereforethe Principles aims and objectives
            of the UBA will be reflected and followed in the School.
          </span>
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
